// Hooks
import { createFormContext, useForm } from '../../../hooks';

export const SignUpContext = createFormContext();

export const useSignUp = useForm;
export default useSignUp;
